module.exports = __webpack_public_path__ + "static/media/photo_003.1401e615.JPG";